"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
exports.uiContext = React.createContext({});
exports.useUiContext = function () { return React.useContext(exports.uiContext); };
var UiProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState({
        snackbarMessage: '',
        celebrationMessage: null,
        homeTab: 0,
        accountTab: 0
    }), values = _b[0], setValues = _b[1];
    var setSnackbarMessage = function (snackbarMessage) {
        setValues(__assign(__assign({}, values), { snackbarMessage: snackbarMessage }));
    };
    var setCelebrationMessage = function (celebrationMessage) {
        setValues(__assign(__assign({}, values), { celebrationMessage: celebrationMessage }));
    };
    var setHomeTab = function (homeTab) {
        setValues(__assign(__assign({}, values), { homeTab: homeTab }));
    };
    var setAccountTab = function (accountTab) {
        setValues(__assign(__assign({}, values), { accountTab: accountTab }));
    };
    return (React.createElement(exports.uiContext.Provider, { value: {
            snackbarMessage: values.snackbarMessage,
            celebrationMessage: values.celebrationMessage,
            homeTab: values.homeTab,
            accountTab: values.accountTab,
            setSnackbarMessage: setSnackbarMessage,
            setCelebrationMessage: setCelebrationMessage,
            setHomeTab: setHomeTab,
            setAccountTab: setAccountTab
        } }, children));
};
exports["default"] = UiProvider;
//# sourceMappingURL=ui-context.js.map